import * as yup from 'yup'

export const labels = [
  {id: 'maintenance', name: 'メンテナンス'},
  {id: 'release', name: 'リリース'},
  {id: 'bug_fix', name: '不具合'},
  {id: 'support', name: 'サポート'},
] as const

export type Labels = (typeof labels)[number]['id']

export const schema = yup.object({
  page: yup.number(),
  per: yup.number().required(),
  q: yup.string(),
  label: yup
    .string()
    .oneOf(labels.map((item) => item.id))
    .optional(),
})

export type Schema = yup.InferType<typeof schema>
